import { render, staticRenderFns } from "./ContrSlope.vue?vue&type=template&id=789cb194&"
import script from "./ContrSlope.vue?vue&type=script&lang=js&"
export * from "./ContrSlope.vue?vue&type=script&lang=js&"
import style0 from "./ContrSlope.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports